import { Component, ChangeDetectionStrategy , inject} from '@angular/core';
import { Router } from '@angular/router';

//Componentes
import { CrearUsuarioComponent } from '@/app/components/catalogos/Usuarios/crear-usuario/crear-usuario.component';
import { EditarUsuarioComponent } from '@/app/components/catalogos/Usuarios/editar-usuario/editar-usuario.component';

//Servicios
import { UsuarioService } from '@/app/services/usuario.service';
import { TokenReaderService } from '@/app/services/security/token-reader.service';


//Librerías externas
import {MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

//Modelos
import { Usuario } from '@/app/models/Usuario';

@Component({
    selector: 'app-lista-usuarios',
    templateUrl: './lista-usuarios.component.html',
    styleUrls: ['./lista-usuarios.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ListaUsuariosComponent {
  private spinner = inject(NgxSpinnerService);

  //Lista de usuarios
  listaUsuarios: Usuario[] = [];


  constructor(
    private usuarioService: UsuarioService,
    private toastr: ToastrService,
    private tokenReader: TokenReaderService, 
    private router: Router,
    private dialog: MatDialog,

  ){
    this.obtenerUsuarios();
  }

  obtenerUsuarios(){
    this.spinner.show();

    let employeeNumber = this.tokenReader.getUserData().usuario;

    this.usuarioService.obtenerUsuarios(employeeNumber).subscribe({
      next: (data: any)=>{
        this.listaUsuarios = data.Users;
        this.spinner.hide();
      },
      error: (err) =>{
        this.spinner.hide();
        console.log(err);
        if(err.error){
          console.log('aqui');
          let { ClassInfo } = err.error;
          this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
        }
      }
    });
  }


  abrirModalCrearUsuario(){
    const dialogRef = this.dialog.open(CrearUsuarioComponent, {
      width: '580px',
      height: '630px',
      panelClass: 'custom-dialog-container',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.updateList) this.obtenerUsuarios();
    });

    this.router.events.subscribe(() => {
      dialogRef.close();
    });
  }


  abrirModalEditarUsuario(usuario: Usuario){
    const dialogRef = this.dialog.open(EditarUsuarioComponent, {
      width: '580px',
      height: '630px',
      // panelClass: 'custom-dialog-container',
      data: usuario,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.updateList) this.obtenerUsuarios();
    });

    this.router.events.subscribe(() => {
      dialogRef.close();
    });
  }


}
